<template>
  <Badge :variant="INFRINGEMENT_STATUS_VARIANT[status]" :size="size">
    {{ t(`infringementStatus.${status}`) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { InfringementStatus } from '@carvia/ros-client-types';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  status: InfringementStatus;
  size?: 'sm' | 'md';
}>();

const INFRINGEMENT_STATUS_VARIANT: Record<InfringementStatus, BadgeVariant> = {
  [InfringementStatus.PENDING]: 'neutral',
  [InfringementStatus.EXTRACTING_DATA]: 'warning',
  [InfringementStatus.EXECUTING]: 'warning',
  [InfringementStatus.AWAITING_USER_CONFIRMATION]: 'info',
  [InfringementStatus.COMPLETED]: 'success',
};
</script>
